import { render, staticRenderFns } from "./CourseIntroduction.vue?vue&type=template&id=319e4e52&scoped=true&"
import script from "./CourseIntroduction.vue?vue&type=script&lang=js&"
export * from "./CourseIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./CourseIntroduction.vue?vue&type=style&index=0&id=319e4e52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319e4e52",
  null
  
)

export default component.exports